import { render } from "./repeat-icon.vue?vue&type=template&id=27953cb4"
import script from "./repeat-icon.vue?vue&type=script&lang=js"
export * from "./repeat-icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__